/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';

const messages = defineMessages({
  title: {id: 'navigation.settings.calendar.periods'},
});

const PeriodsItem = () => (
  <RouteLinkItem
    route="midas/settings/calendar/periods"
    title={messages.title}
  />
);

export default PeriodsItem;
